const MembershipConditionsErrorMessages = {
  ImproperStructure: "Membership Condition is of invalid structure",
  NotRecognizedInputField: "Unrecognised Input Field in the membership condition",
  InputFieldAndOperatorConflict:
    "An input field and a condition is in contrary in the given membership condition",
  NotSupportedOperators: "Membership conditions have unsupported operators",
};

export const MembershipConditionsErrors = {
  DisjunctionAboveHeight0: {
    message: MembershipConditionsErrorMessages.ImproperStructure,
    errorCode: "Disjunction above height 0",
  },
  ConjunctionAboveHeight1: {
    message: MembershipConditionsErrorMessages.ImproperStructure,
    errorCode: "Conjunction above height 1",
  },
  ConjunctionContainsSpecialCondition: {
    message: MembershipConditionsErrorMessages.ImproperStructure,
    errorCode: "Conjunction contains special condition",
  },
  NotRecognizedInputField: {
    message: MembershipConditionsErrorMessages.NotRecognizedInputField,
    errorCode: "Not recognized input field",
  },
  EqualityMismatchInputField: {
    message: MembershipConditionsErrorMessages.InputFieldAndOperatorConflict,
    errorCode: "Equality mismatch input field",
  },
  StringInMismatchInputField: {
    message: MembershipConditionsErrorMessages.InputFieldAndOperatorConflict,
    errorCode: "StringIn mismatch input field",
  },
  ArrayContainsMismatchInputField: {
    message: MembershipConditionsErrorMessages.InputFieldAndOperatorConflict,
    errorCode: "Array contsins mismatch input field",
  },
  NotSupportedOperators: {
    message: MembershipConditionsErrorMessages.NotSupportedOperators,
    errorCode: "Not supported operator",
  },
  NullConditionAboveHeight0: {
    message: MembershipConditionsErrorMessages.ImproperStructure,
    errorCode: "Null condition above height 0",
  },
};
